"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = void 0;
var vue_1 = require("vue");
var _withScopeId = function (n) { return (vue_1.pushScopeId("data-v-a9c3fbce"), n = n(), vue_1.popScopeId(), n); };
var _hoisted_1 = { class: "message-merger" };
var _hoisted_2 = ["data-value"];
var _hoisted_3 = { class: "merger-title" };
var _hoisted_4 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return vue_1.createElementVNode("span", { class: "merger-label" }, " 聊天记录", -1); });
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (vue_1.openBlock(), vue_1.createElementBlock("div", _hoisted_1, [
        vue_1.createElementVNode("div", {
            class: "merger-box",
            "data-value": _ctx.data.message
        }, [
            vue_1.createElementVNode("p", _hoisted_3, vue_1.toDisplayString(_ctx.data.title), 1),
            (vue_1.openBlock(true), vue_1.createElementBlock(vue_1.Fragment, null, vue_1.renderList(_ctx.data.abstractList, function (item, index) {
                return (vue_1.openBlock(), vue_1.createElementBlock("p", {
                    class: "merger-text",
                    key: index
                }, vue_1.toDisplayString(item), 1));
            }), 128))
        ], 8, _hoisted_2),
        _hoisted_4
    ]));
}
exports.render = render;
